import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { MediaQuery, Shadow } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const Wrapper = styled.div`
  margin: auto;
  padding-bottom: ${({ isPostSlice }) => !isPostSlice && '50px'};
`;

export const StyledTitle = styled.h2`
  ${Typography.XXXXXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  width: 100%;
  text-align: center;
  margin-top: 35px;
`;

export const SingleCardWrapper = styled.div`
  background-color: ${Color.ZIRCON};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const TransformContainer = styled.div`
  transform: translateY(50px);

  & > * {
    box-shadow: ${Shadow.BLUE_BOX};
    background-color: ${Color.WHITE};
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  padding-top: ${({ isHigher }) => isHigher && `100px`};

  ${MediaQuery.M_AND_DOWN} {
    padding: ${({ isHigher }) =>
      isHigher ? '100px 15px 0px 15px' : '0px 15px'};
  }
`;
